
import BellaVita from "../assets/BellaVita.jpeg"
import bestBuy2 from "../assets/bestBuy2.png"
import til from "../assets/til.png"

export const ProjectList = [
   {
      name: "Til",
      image: til,
      skills: "NextJS, Firebase, Tailwind CSS",
      url: "https://til-vert.vercel.app/",
      git: "https://github.com/is1dd/Til",
      des: "Til allows you to share your thought with everyone on the app."
    },
  {
    name: "BellaVita Clone",
    image: BellaVita,
    skills: "React, Chakra UI",
    url: "https://organicbazaar.vercel.app/",
    git: "https://github.com/is1dd/Bellavita-organic",
    des: "Organic Bazaar ecommerce app."
  },
    {
    name: "Best Buy Clone",
    image: bestBuy2,
    skills: "Vanilla JavaScript,HTML,CSS",
    url: "https://bestbuy-in.netlify.app/",
    git: "https://github.com/is1dd/Best-Buyers",
    des: "Cloned Best Buy Website which allows users to buy electronic items and clothes."
  },
  
];
